var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { Accordion, AccordionItem, AccordionPanel, CollapsibleCardHeader } from 'shared/components';
import { isEmpty } from 'lodash';
/**
 * A card that can expand and collapse. Content can be almost anything, such as a tree of react nodes.
 * We use Chakra's Accordion* components for this, since they come with accessibility features
 * specific to accordions, as well as the other small prepacked features it brings.
 *
 * See Chakra's Accordion* API here: https://chakra-ui.com/docs/components/disclosure/accordion
 *
 * @param {CollapsibleCardProps} props CollapsibleCardProps
 * @returns {React.ReactNode} CollapsibleCard
 */
var CollapsibleCard = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, _b = _a.isOpen, isOpen = _b === void 0 ? false : _b, _c = _a.errorsInCard, errorsInCard = _c === void 0 ? {} : _c, _d = _a.Header, Header = _d === void 0 ? CollapsibleCardHeader : _d, children = _a.children, onChange = _a.onChange, props = __rest(_a, ["title", "subtitle", "isOpen", "errorsInCard", "Header", "children", "onChange"]);
    errorsInCard.asd;
    var updatedIndex = isOpen ? [0] : [];
    var _e = useState(updatedIndex), index = _e[0], setIndex = _e[1];
    var hasError = errorsInCard && !isEmpty(errorsInCard);
    useEffect(function () {
        if (!hasError) {
            setIndex(updatedIndex);
        }
    }, [isOpen]);
    useEffect(function () {
        if (hasError) {
            setIndex([0]);
        }
    }, [errorsInCard]);
    return (_jsx(Accordion, __assign({ index: index, allowToggle: true, mb: 4 }, props, { 
        // See https://github.com/chakra-ui/chakra-ui/issues/5176#issuecomment-984773584
        onChange: function (expandedIndex) {
            if (hasError)
                return;
            expandedIndex === -1 ? setIndex([]) : setIndex([0]);
            if (onChange) {
                onChange(expandedIndex !== -1);
            }
        } }, { children: _jsxs(AccordionItem, { children: [_jsx(Header, { title: title, subtitle: subtitle, hideIcon: !children, isOpen: index[0] === 0 ? true : false, dataTitle: true }), children && _jsx(AccordionPanel, { children: children })] }) })));
};
export { CollapsibleCard };
